import * as angular from "angular";
import "angular-route";
import {GroupsInitService} from "../groups/groups-init/groups-init.service";
import {GroupsService} from "../common/groups/groups.service";
import {StudyProgramsService} from "../common/study-programs/study-programs.service";
import {InstructorsService} from "../common/instructors/instructors.service";
import {StudentsService} from "../common/students/students.service";
import {PreferenceService} from "../common/preference/preference.service";
import {UserSessionService} from "../common/user-session/user-session.service";

export function initRoutes(app: angular.IModule) {
    /* @ngInject */
    app.config(function($routeProvider: angular.route.IRouteProvider) {
        $routeProvider
            .when("/:tenantId", {
                template: "<groups></groups>",
                resolve: {
                    /* @ngInject */
                    initData: function ($route: angular.route.IRouteService,
                                        groupsInitService: GroupsInitService) {
                        return groupsInitService($route.current.params.tenantId);
                    }
                }
            })
            .when("/:tenantId/assign-programs", {
                template: "<assign-programs></assign-programs>",
                resolve: {
                    /* @ngInject */
                    groups: function ($route: angular.route.IRouteService,
                                      groupsService: GroupsService) {
                        return groupsService.getForAssignment($route.current.params.tenantId);
                    },
                    /* @ngInject */
                    studyPrograms: function ($route: angular.route.IRouteService,
                                             studyProgramsService: StudyProgramsService) {
                        return studyProgramsService.getStudyPrograms($route.current.params.tenantId, true);
                    },
                    /* @ngInject */
                    instructors: function ($route: angular.route.IRouteService,
                                           instructorsService: InstructorsService) {
                        return instructorsService($route.current.params.tenantId);
                    }
                }
            })
            .when("/:tenantId/group-detail/:groupId", {
                 template: "<group-detail></group-detail>",
                 resolve: {
                    /* @ngInject */
                    group: function ($route: angular.route.IRouteService,
                                      groupsService: GroupsService) {
                        return groupsService.calculateStudentGrade(groupsService.
                               getOne($route.current.params.groupId, $route.current.params.tenantId));
                    },
                    /* @ngInject */
                    studyPrograms: function ($route: angular.route.IRouteService,
                                              studyProgramsService: StudyProgramsService) {
                        return studyProgramsService.getStudyPrograms($route.current.params.tenantId, true);
                    },
                    /* @ngInject */
                    instructors: function ($route: angular.route.IRouteService,
                                            instructorsService: InstructorsService) {
                        return instructorsService($route.current.params.tenantId);
                    }
                }
             })
            .when("/:tenantId/default-group-detail/:groupId", {
                template: "<default-group-detail></default-group-detail>",
                resolve: {
                    /* @ngInject */
                    group: function ($route: angular.route.IRouteService,
                                     groupsService: GroupsService) {
                        return groupsService.calculateStudentGrade(groupsService.
                        getOne($route.current.params.groupId, undefined));
                    },
                    /* @ngInject */
                    availableStudents: function ($route: angular.route.IRouteService,
                                                 studentsService: StudentsService) {
                        let defaultGrades = [];

                        if($route.current.params.defaultGrades) {
                            $route.current.params.defaultGrades.split(",").forEach(function (value) {
                                let defaultGrade = Number(value);
                                if (!isNaN(defaultGrade)) {
                                    defaultGrades.push(defaultGrade);
                                }
                            });
                        }

                        return studentsService.getByGrade($route.current.params.tenantId, defaultGrades);
                    }
                }
            })
            .when("/:tenantId/manage-defaults", {
                template: "<manage-defaults></manage-defaults>",
                resolve: {
                    // TODO this will likely change when current default prefs become available
                    /* @ngInject */
                    studyPrograms: function ($route: angular.route.IRouteService,
                                             studyProgramsService: StudyProgramsService) {
                        return studyProgramsService.getStudyPrograms($route.current.params.tenantId, true);
                    },
                    /* @ngInject */
                    preference: function ($route: angular.route.IRouteService,
                                             preferenceService: PreferenceService, userSessionService: UserSessionService) {
                        if (userSessionService.isDistrictMode())  {
                            return preferenceService.getInstitutionPreference(userSessionService.getDistrictTenantId());
                        } else {                       
                            return preferenceService.getInstitutionPreference($route.current.params.tenantId);
                        }
                    }
                }
            })
            .when("/:tenantId/set-ap-programs", {
                template: "<set-ap-programs></set-ap-programs>",
                resolve: {
                    /* @ngInject */
                    subscriptionStudyPrograms: function ($route: angular.route.IRouteService,
                                                         studyProgramsService: StudyProgramsService) {
                        return studyProgramsService.getSubscriptionStudyPrograms($route.current.params.tenantId, true);
                    }
                }
            })
            .otherwise({ redirectTo: "/" });
    });
}


/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/app-routes/app.routes.ts
 **/